/**
 * Intercepts product variation link clicks in quick-buy modal
 * and reloads the quick view instead of navigating to product page
 */
(function() {
  'use strict';

  // Helper function to reload quick-buy modal content
  async function reloadQuickBuyModal(quickBuyModal, productUrl) {
    // Ensure URL is absolute
    if (productUrl.startsWith('/')) {
      productUrl = window.location.origin + productUrl;
    }

    // Update the product-url attribute (store relative URL)
    const relativeUrl = productUrl.replace(window.location.origin, '');
    quickBuyModal.setAttribute('product-url', relativeUrl);

    // Check if modal is already open
    const isOpen = quickBuyModal.hasAttribute('open');

    if (isOpen) {
      // If modal is already open, manually reload the content
      // This replicates what QuickBuyModal.show() does
      const controls = quickBuyModal.querySelectorAll('[aria-controls="' + quickBuyModal.id + '"]');
      const showLoadingBar = Array.from(controls).every(control => control.querySelector('button-content') === null);
      
      if (showLoadingBar) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      }

      quickBuyModal.setAttribute('aria-busy', 'true');
      controls.forEach(control => {
        control.setAttribute('aria-busy', 'true');
      });

      try {
        // Fetch the new product page
        const response = await fetch(productUrl);
        const responseContent = await response.text();
        const tempDoc = new DOMParser().parseFromString(responseContent, 'text/html');
        const quickBuyContent = tempDoc.getElementById('quick-buy-content');

        if (quickBuyContent) {
          // Replace the modal content
          quickBuyModal.replaceChildren(quickBuyContent.content.cloneNode(true).firstElementChild);
        }
      } catch (error) {
        console.error('Error reloading quick-buy modal:', error);
      } finally {
        quickBuyModal.setAttribute('aria-busy', 'false');
        controls.forEach(control => {
          control.setAttribute('aria-busy', 'false');
        });

        if (showLoadingBar) {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        }
      }
    } else {
      // If modal is closed, just update the URL - it will load when opened
      // Or we could call show() to open it with the new product
      if (typeof quickBuyModal.show === 'function') {
        quickBuyModal.show();
      }
    }
  }

  // Use event delegation to handle clicks on product variation links
  // This works even when content is dynamically loaded
  document.addEventListener('click', function(event) {
    const quickBuyModal = event.target.closest('quick-buy-modal');
    
    // Only handle clicks inside quick-buy-modal
    if (!quickBuyModal) {
      return;
    }

    // Find the clicked link (could be the link itself or a child element)
    const link = event.target.closest('a[href*="/products/"]');
    
    if (!link) {
      return;
    }

    // Check if this link is inside a product-variations block
    // Product variations are rendered inside .variant-picker__option-values
    const variantPickerOption = link.closest('.variant-picker__option-values');
    
    if (!variantPickerOption) {
      return;
    }

    // Check if we're in the quick-buy context
    const quickBuyInfo = link.closest('.quick-buy__info');
    
    if (!quickBuyInfo) {
      return;
    }

    // Prevent default navigation
    event.preventDefault();
    event.stopPropagation();

    // Get the product URL from the link
    const productUrl = link.getAttribute('href');
    
    if (!productUrl) {
      return;
    }

    // Reload the quick view
    reloadQuickBuyModal(quickBuyModal, productUrl);
  }, true); // Use capture phase to catch events early
})();
